import type { DataFlowBuilder } from '@/engine/DataFlow';
import * as DT from './TTVRDataTypes';
import * as Algo from './TTVRAlgorithmHelpers';

export function buildCommissureAlgorithm(builder: DataFlowBuilder, descriptor: string): void {
  builder.name('pt_' + descriptor + '_imported').declare(DT.Point);

  builder
    .name('tp.pt_' + descriptor + '_rotation')
    .bindRaw(
      Algo.tuneValue,
      DT.NumberT,
      builder.name('tp.pt_' + descriptor + '_rotation.dflt').define(new DT.NumberT(0)),
      builder.name('tp.pt_' + descriptor + '_rotation.user').define(new DT.NumberT(0)),
      builder.name('tp.pt_' + descriptor + '_rotation.appr').define(new DT.NumberT(0)),
      builder.name('tp.pt_' + descriptor + '_rotation.flag').define(Algo.defaultTuneFlag())
    );

  builder
    .name('vec_' + descriptor + '_initial')
    .bind(Algo.findCommissureInitialVectorTTVR, DT.Vector, 'commissure_spline_area', 'pt_' + descriptor + '_imported');

  builder
    .name('pt_' + descriptor)
    .bind(
      Algo.findCommissurePointTTVR,
      DT.Point,
      'landing_zone_spline',
      'vec_' + descriptor + '_initial',
      'tp.pt_' + descriptor + '_rotation'
    );
}

export function buildCommissureCommonAlgorithm(builder: DataFlowBuilder, descriptors: Array<string>): void {
  builder.name('available_commissure_points').define(new DT.IdentifiersList(descriptors));
}
